import { connect } from "react-redux";
import RouteSummary from "./RouteSummary";
import { changeRoute } from "../../store/actions";

const mapStateToProps = state => ({
  routeRequest: state.routeRequest,
  restrictions: state.restrictions,
  calculations: state.calculations 
});

const mapDispatchToProps = dispatch => ({
  onRouteChange: () => dispatch(changeRoute()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RouteSummary);
